<!-- 现场退次 列表 页面 -->
<template>
  <h-list-page class="inFactoryRejectsListPage_style">
    <h-card :title="h_i18n('5148fcc0412bafcd98e04d4d183d8e18')" width="100%" is-search @change-method="changeMethod" footer>
      <h-area>
        <h-search :title="h_i18n('f1edca9f040d256cee01ef89fa5499f0')">
          <h-autocomplete popper-class="planHidden" v-model="searchData.mtlNo" :fetch-suggestions="mtlNoChange"
            :trigger-on-focus="false" @input="() =>
              searchData.mtlNo.length < 4 ? (plan.showMtlPlan = false) : ''" @clear="plan.showMtlPlan = false"
            clearable :placeholder="h_i18n('3bdbd9312d3a6f04ebdb6b99ac0f2f4a')" @blur="detailBlur('showMtlPlan')" @focus="detailFocus('showMtlPlan')">
          </h-autocomplete>
          <h-detail width="400px" top="34px" left="0px">
            <el-table v-show="plan.showMtlPlan" v-loading="data.mtlLoading" :data="data.mtlNoList" border size="small"
              max-height="252" @row-click="clickMtlNo" @mousedown="plan.planBlur = true">
              <el-table-column prop="mtlNo" :label="h_i18n('56ca9a2de6d54b00fb98ab39cce17089')" width="120"></el-table-column>
              <el-table-column prop="mtlName" :label="h_i18n('901fcadda8a5683e7a83a0c811ff4382')"></el-table-column>
            </el-table>
            <div v-if="plan.showMtlPlan && plan.MtlOver600" style="color: red;height: 20px;background-color: #fff;
                padding-top: 3px;">
              <span style="padding-left: 10px; font-size: 12px">{{ h_i18n('a1fc8066cb705fef975d7db6b39eaa79') }}</span>
            </div>
          </h-detail>
        </h-search>
        <h-search :title="h_i18n('901fcadda8a5683e7a83a0c811ff4382')">
          <h-input v-model="searchData.mtlName" clearable @change="changeNull(searchData.mtlName, 'mtlName')"></h-input>
        </h-search>
        <h-search :title="h_i18n('7d0d9d5a6a61aa1f3037e2514fe3a18d')">
          <h-select v-model="searchData.sybName" clearable filterable
            @change="changeNull(searchData.sybName, 'sybName')">
            <h-option v-for="item in data.factoryArray" :label="item.departmentName"
              :value="item.departmentName"></h-option>
          </h-select>
        </h-search>
        <h-search :title="h_i18n('2739c66a785c303a52967b2e511a2e87')">
          <h-select :placeholder="h_i18n('708c9d6d2ad108ab2c560530810deae9')" v-model="searchData.rejectsType" clearable filterable
            @change="changeNull(searchData.rejectsType, 'rejectsType')">
            <h-option label="TC" :value="1243"></h-option>
            <h-option label="FX" :value="1244"></h-option>
            <h-option label="FK" :value="1245"></h-option>
            <h-option :label="h_i18n('4addd68e6247a3ce7282eb8c502dbd00')" :value="3006"></h-option>
            <h-option :label="h_i18n('32a40a1cd4ad790301c810307fa27f1f')" :value="3007"></h-option>
          </h-select>
        </h-search>
        <h-search :title="h_i18n('37769e25fffd760203c860702167cd26')">
          <h-select v-model="searchData.statusChangeId" :placeholder="h_i18n('708c9d6d2ad108ab2c560530810deae9')" clearable
            @change="changeNull(searchData.statusChangeId, 'statusChangeId')">
            <h-option value="自动认可" :label="h_i18n('31b88d82c7738269292a70555719d18d')"></h-option>
            <h-option value="供方认可" :label="h_i18n('fcbda1a3b9a1f991de0b81f94ee7365c')"></h-option>
            <h-option value="待审核" :label="h_i18n('5cb424765cb101866f47ca115605ce3b')"></h-option>
            <h-option value="待终判" :label="h_i18n('9109d5ff67cfd588c1d5265d160a958f')"></h-option>
            <h-option value="终判通过" :label="h_i18n('db6e70ed7144c383e800dd36fe849cdf')"></h-option>
            <h-option value="终判不通过" :label="h_i18n('85d8dd6ea355bf679c4af04dc3c611c1')"></h-option>
          </h-select>
        </h-search>
        <h-search class="searchColItem" :title="h_i18n('0b502cec5dffcbb1cf611880b0cdd066')">
          <h-date-picker
            @change="TimeChange(searchData.dateFourth, { start: 'beginDateFourth', end: 'endDate1Fourth' })"
            v-model="searchData.dateFourth" type="daterange" :start-placeholder="h_i18n('a3e3b88377c8a2f34e0f9ef6e67dbe62')" :end-placeholder="h_i18n('12f1d7ef38af6326c94fd11688f5b453')" clearable
            clear-icon="el-icon-error" prefix-icon="iconfont icon-rili2" />
        </h-search>
        <template #operate>
          <h-button type="primary" :loading="loading" @click="getInfo(true)">
            <template #icon>
              <search />
            </template>{{ h_i18n('bee912d79eefb7335988c4997aa9138d') }}</h-button>
        </template>
      </h-area>
    </h-card>
    <h-table-card :title="h_i18n('93fbc4b2599c08ddc368dfc24ca259e2')" :is-left="5" :h-data="data.tableData">
      <template #buttonGroup>
        <h-button-group>
          <template v-for="item in data.btnListOfSqm" :key="item.code">
            <h-button v-if="item.code == 'mkhl_xctc_xctc_export'" :loading="loadingFunction(item.code)" type="default"
              @click="btnFunction(item.code)">
              <template #icon>
                <Download size="14" fill="rgba(0, 0, 0, 0.6)" />
              </template>{{ h_i18n('55405ea6ff6fd823ffab7e6b10ddfa95') }}</h-button>
          </template>
          <div class="tipBox_yellow">
            <img src="@/assets/img/tips-icon.png" class="tip-img" />{{ h_i18n('d17f22a7d4885ad074a6e11a63603990') }}</div>
        </h-button-group>
      </template>

      <el-table :empty-text="h_i18n('71de786302ccfb91781f054c4fd02ec8')" :data="data.tableData" height="540" @selection-change="listCheckBoxChange" border
        v-loading="data.tableLoading" size="small" style="width: 100%; min-height: 540px">
        <!-- <el-table-column type="selection" width="55" :selectable="selectable" align="center" /> -->
        <el-table-column type="index" :label="h_i18n('faaadc447b1c2b1adc920d9c9aedcc25')" width="48"></el-table-column>
        <el-table-column prop="rejectStatusName" :label="h_i18n('3fea7ca76cdece641436d7ab0d02ab1b')" min-width="80"></el-table-column>
        <el-table-column prop="rejectsId" :label="h_i18n('96ad1b86c31e8f1965a3fdafae75975d')" min-width="160"></el-table-column>
        <el-table-column prop="mtlNo" :label="h_i18n('f1edca9f040d256cee01ef89fa5499f0')" min-width="120">
          <template #default="{ row }">
            <span style="color: #165dff; cursor: pointer" @click="detailBtn(row)">{{ row.mtlNo }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="mtlName" :label="h_i18n('901fcadda8a5683e7a83a0c811ff4382')" min-width="150"></el-table-column>
        <el-table-column prop="materielCategoryName" :label="h_i18n('33ac341a8748c430f721aa43dcf9f3b6')" min-width="80"></el-table-column>
        <el-table-column prop="sybName" :label="h_i18n('7d0d9d5a6a61aa1f3037e2514fe3a18d')" min-width="120"></el-table-column>
        <el-table-column prop="lineName" :label="h_i18n('767b3bea1695be77ce9c2785ef66ad72')" min-width="80"></el-table-column>
        <el-table-column prop="teamName" :label="h_i18n('75237166e951947443eea058979cae11')" min-width="80"></el-table-column>
        <el-table-column prop="rejectsReasonName" :label="h_i18n('c1fcb90f50319828d79871f435448d17')" min-width="150"></el-table-column>
        <el-table-column prop="number" :label="h_i18n('0bf60b32f9db93b87e08763b1c815469')" width="80"></el-table-column>
        <el-table-column prop="unit" :label="h_i18n('f2996845b6bf0a07fe26f74f35e42ebe')" width="80"></el-table-column>
        <el-table-column prop="flawTypeName" :label="h_i18n('74c62f1fcddd7b5f905eacca4b6b3ab1')" width="90"></el-table-column>
        <el-table-column prop="isLowError" :label="h_i18n('a7beb26b9737d5af012d9bb77c8eb59e')" width="90">
          <template #default="{ row }">
            <span>{{ row.isLowError == 1 ? h_i18n('0a60ac8f02ccd2cf723f927284877851') : h_i18n('c9744f45e76d885ae1c74d4f4a934b2e') }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="flawMark" :label="h_i18n('0e73c6d4d0fd0664717ad4d66f98aba6')" width="150"></el-table-column>
        <el-table-column prop="rejectsTypeName" :label="h_i18n('2739c66a785c303a52967b2e511a2e87')" width="90"></el-table-column>
        <el-table-column prop="isrtDate" :label="h_i18n('0039880117c13787732d259f5bc9f7f5')" min-width="170">
          <template #default="{ row }">
            <span>{{ time(row.isrtDate, 6) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="finalResultDate" :label="h_i18n('0b502cec5dffcbb1cf611880b0cdd066')" min-width="170">
          <template #default="{ row }">
            <span>{{ time(row.finalResultDate, 6) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="appealStatus" :label="h_i18n('37769e25fffd760203c860702167cd26')" width="80"></el-table-column>
        <el-table-column prop="operation" :label="h_i18n('2b6bc0f293f5ca01b006206c2535ccbc')" width="180" class-name="btn_cell_style">
          <template #default="{ row }">
            <h-button-group>
              <h-button type="primary" @click="btnFunction('mkhl_xctc_xctc_RKBUTTON', row)"
                :disabled="isDisabled(row)">{{ h_i18n('191a39634a0499cfbe8b6f5fc822d74b') }}</h-button>
              <h-button type="danger" @click="btnFunction('mkhl_xctc_xctc_SSBUTTON', row)"
                :disabled="isDisabled(row)">{{ h_i18n('ce6326e846e2c23e9a83fcfb9774685f') }}</h-button>
            </h-button-group>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination background @size-change="handleSizeChange" @current-change="getInfo"
        v-model:currentPage="searchData.pageNo" :page-size="10" layout="total, prev, pager, next,jumper"
        :total="data.total">
      </el-pagination>

    </h-table-card>
  </h-list-page>
</template>

<script setup>
//Automatic script writing.
import h_i18n from '@/utils/Internationalization';

import { reactive, getCurrentInstance, onMounted, ref, nextTick, onActivated, onDeactivated } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import axios from 'axios';
const { proxy, ctx } = getCurrentInstance();
const route = useRoute();
const router = useRouter();
const searchData = reactive({
  mtlNo: '',
  pageNo: 1,
  pageSize: 10,
  finalResult: h_i18n('97c61c38ef75de936a3dd852843e6a92'),
  queryFlag: 'sqm',
  // relatedRoleId: "8",
  rejectStatusAll: "all",
});
const data = reactive({
  exportBtnCodeOfHac: h_i18n('55405ea6ff6fd823ffab7e6b10ddfa95'),
  keepalivestatus: 0,
  clickRowList: [],
  exportLoading: false,
  tableLoading: false,
  btnListOfSqm: [],
  tableData: [],
  total: 0,
});
// 按钮权限
const btnFunction = (btnCode, row) => {
  switch (btnCode) {
    case "mkhl_xctc_xctc_export":// 导出
      excleBtn()
      break;
    case "mkhl_xctc_xctc_RKBUTTON": // 认可
      approval(row)
      break;
    case "mkhl_xctc_xctc_SSBUTTON": // 申诉
      createAppeal(row)
      break;
  }
}
// 按钮loading
const loadingFunction = (btnCode) => {
  switch (btnCode) {
    case "mkhl_xctc_xctc_export":// 导出
      return data.exportLoading
  }
}
// 申诉/认可 权限
const isDisabled = (row) => {
  if (!row.appealStatus) {
    if (row.isrtDate && new Date(row.isrtDate).getTime() < 1669113000000) {
      return true
    } else {
      return false
    }
  } else {
    return true
  }
}
// 查看详情
const detailBtn = (row) => {
  proxy.$router.push({
    path: '/inFactoryRejectsDetailPage',
    query: {
      mtlNo: row.mtlNo,
      dataFrom: 'sqm',
      rejectsId: row.rejectsId,
    },
  });
};


/**
 * 勾选操作
 * @param {*} rowArr 选中行
 */
const listCheckBoxChange = (rowArr) => {
  data.rowListOfCheck = rowArr
  console.log("data.rowListOfCheck", data.rowListOfCheck);
};
// 时间范围选择
const TimeChange = (date, { start, end }) => {
  if (date) {
    searchData[start] = proxy.time(date[0]);
    searchData[end] = proxy.time(date[1]);
  } else {
    searchData[start] = undefined;
    searchData[end] = undefined;
  }
};
// 认可
const approval = (row) => {
  proxy.info({
    message: h_i18n('99652ba7c48d6bba558e3b2182e9c31a'), title: h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'),
    confirmButtonText: h_i18n('e83a256e4f5bb4ff8b3d804b5473217a'), cancelButtonText: h_i18n('625fb26b4b3340f7872b411f401e754c'), callback: (action) => {
      if (action == "confirm") {
        proxy.$http({
          method: "post",
          url: `/base/RefusalAppeal/updateBLJAppealStaus?rejectsId=${row.rejectsId}${h_i18n('a7846753f25b1da6cbca4f5d82ace859')}${searchData.supplyCode}&username=${data.trueName}`
        }).then((res) => {
          if (res.data && res.data.data === '成功') {
            proxy.success(h_i18n('27f5ab725ba1a4caa5cd918d6057757d') || res.data.data);
            getInfo();
          } else {
            proxy.info(res.data.msg || h_i18n('f98989cbae9990c8ddfe4d0e2d1d0d7c'));
          }
        }).catch(err => {
          proxy.info(err || h_i18n('f98989cbae9990c8ddfe4d0e2d1d0d7c'));
        })
      }
    }
  });
};
// 申诉
const createAppeal = (row) => {
  proxy.info({
    message: h_i18n('28b56e9ecf8f2fd66941460fb688aa57'), title: h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'),
    confirmButtonText: h_i18n('e83a256e4f5bb4ff8b3d804b5473217a'), cancelButtonText: h_i18n('625fb26b4b3340f7872b411f401e754c'), callback: (action) => {
      if (action == "confirm") {
        proxy.$router.push({
          path: '/inFactoryRejectsComplaint',
          query: {
            //要传的参数
            rejectsId: row.rejectsId,
            supplyCode: data.supplyCode,
            supplyName: data.supplyName,
            applyName: data.trueName,
            trueName: data.trueName,
            userName: data.userName,
            dataFrom: 'sqm',
            kindType: 'sqmAdd',
            comeFrom: h_i18n('93fbc4b2599c08ddc368dfc24ca259e2'),
          },
        });
      }
    }
  });
};


const getInfo = (flag) => {
  if (flag === true) {
    searchData.pageNo = 1
  }
  data.tableLoading = true
  proxy.$http({
    method: "post",
    url: "/base/rejectsReplenishment/rejectsReplenishmentList",
    data: {
      ...searchData,
      dateFourth: undefined,
      appealStatus:searchData.statusChangeId,
      dateOne: undefined,
    },
  }).then(res => {
    console.log(res)
    data.tableData = res.data.data.rejectsReplenishmentDTOPage.records
    data.total = res.data.data.rejectsReplenishmentDTOPage.total
  }).catch(err => {

  }).finally(() => {
    data.tableLoading = false
  })
}
// 导出
const excleBtn = () => {
  if (data.total > 5000) {
    proxy.warning(
      { message: h_i18n('748c802d8fe36ada78520df791295747'), title: h_i18n('f148292ae0c683ca6fe4246350d309f6') },
      {
        confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
        callback: (action) => { },
      }
    );
    return;
  }
  data.exportLoading = true;
  proxy.startLoading(h_i18n('71c9cb24c7a83ced8d89f2008a2ae8a6'));
  proxy.httpFile({
    method: 'post',
    url: '/base/rejectsReplenishment/rejectsReplenishmentExport',
    data: {
      ...searchData,
      dateFourth: undefined,
      appealStatus:searchData.statusChangeId,
      dateOne: undefined,
    },
  }, h_i18n('2a2c24302f81793ea5c074e59031f7c6')).then(res => {

  }).catch(err => {

  }).finally(() => {
    data.exportLoading = false
    proxy.closeLoading()
  })
}
// input为空时undefined
const changeNull = (value, key) => {
  if (value === "") {
    searchData[key] = undefined;
  }
  if(key === 'sybId'){
    if(value === ''){
      searchData.sybName = '';
    }else{
      searchData.sybName = data.factoryArray.find(item=>{
        return item.departmentId === value
      })?.departmentName
    }
  }
};
// 两个模糊查询相关
const http = reactive({
  mtlSearchHttp: false,
});
const plan = reactive({
  showMtlPlan: false,
  planBlur: false,
  MtlOver600: false,
});

// 弹窗失焦
const detailBlur = (v) => {
  if (!plan.planBlur) {
    plan[v] = false;
  }
};
// 弹窗聚焦
const detailFocus = (v) => {
  plan.planBlur = false;
  if (v == "showMtlPlan") {
    if (searchData.mtlNo.length >= 4) {
      plan[v] = true;
    }
  }
};
const clickMtlNo = (row) => {
  searchData.mtlNo = row.mtlNo;
  plan.showMtlPlan = false;
};

/**
 * 专用号模糊查询
 */
const mtlNoChange = () => {
  plan.planBlur = false;
  if (http.mtlSearchHttp) http.mtlSearchHttp.cancel();
  http.mtlSearchHttp = axios.CancelToken.source();
  if (searchData.mtlNo.length < 4) {
    plan.showMtlPlan = false;
  } else {
    plan.showMtlPlan = true;
    data.mtlLoading = true;
    proxy
      .$http({
        method: "POST",
        url: "/base/basicData/searchMaterielList",
        headers: { "content-type": "application/json" },
        data: {
          mtlNo: searchData.mtlNo,
        },
        cancelToken: http.mtlSearchHttp.token,
      })
      .then((res) => {
        data.mtlNoList = res.data.data;
        if (data.mtlNoList.length >= 600) {
          plan.MtlOver600 = true;
          data.mtlLoading = false;
        } else {
          plan.MtlOver600 = false;
          data.mtlLoading = false;
        }
      }).catch((e) => { });
  }
};
/* 传高度
*/
const changeMethod = () => {
  proxy.postThisPageHeight();
};
// 互联工厂
const searchFactory = () => {
  // if(query){
  proxy.$http({
    url: '/base/sysStructureTree/getSyb?sybName=',
    method: 'get'
  }).then(res => {
    data.factoryArray = res.data.data
  }).catch(err => {

  }).finally(() => {

  })
  // }
}
// 两个模糊查询结束
onMounted(() => {
  if (route.query) {
    data.supplyCode = route.query.supplyCode;
    searchData.supplyCode = route.query.supplyCode;
    data.supplyName = route.query.supplyName;
    data.trueName = route.query.trueName;
    data.roleCode = route.query.roleCode;
    data.userName = route.query.userName;
    searchData.applyName = route.query.trueName;
    searchData.trueName = route.query.trueName;
    searchData.relatedRoleId = route.query.roleId;
    searchData.roleCode = route.query.roleCode;
  }
  
  if (route.query.dataFrom != 'sqm') {
    proxy.$router.replace('/404')
    return
  }
  if (!route.query.supplyCode) {
    proxy.info({
      title: h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'), message: h_i18n('c0f92e28b64a4268408f10aa60dc47c8'), confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
      callback: (action) => {
        proxy.$router.back()
      },
    })
    return
  }
  if (route.query.parentId && route.query.parentId != 'null' && route.query.parentId != 'undefined' && route.query.parentId != '') {
    let p = proxy.getButtonFromSqm(route.query.parentId, route.query.roleCode)
    p.then(res => {
      if (res.length > 0) {
        data.btnListOfSqm = res
        console.log(data.btnListOfSqm)
      }
    })
  }
  // 默认查询时间
  searchData.beginDateFourth = proxy.time((new Date().getTime() - 24 * 30 * 60 * 60 * 1000))
  searchData.endDate1Fourth = proxy.time((new Date().getTime()))
  searchData.dateFourth = [searchData.beginDateFourth, searchData.endDate1Fourth]
  searchFactory()
  getInfo();
})
onActivated(() => {
  if (data.keepalivestatus == 0) {
    // console.log("首次打开");
    data.keepalivestatus++
    proxy.postThisPageHeight();
  } else {
    proxy.postThisPageHeight();
    // console.log("操作完之后打开");
    if (route.query.dataFrom != 'sqm') {
      proxy.$router.replace('/404')
      return
    }
    if (!route.query.supplyCode) {
      proxy.info({
        title: h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'), message: h_i18n('c0f92e28b64a4268408f10aa60dc47c8'), confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
        callback: (action) => {
          proxy.$router.back()
        },
      })
      return
    }
    getInfo()
  }
  proxy.postThisPageHeight();
})
onDeactivated(() => {
  // console.log("keepalive-deactivated页面关闭时触发");
})
</script>
<style lang="scss">
.inFactoryRejectsListPage_style {
  .btn_cell_style {
    padding: 0px !important;
  }

  .haier-card .haier-card--body .el-table tr td {
    padding: 12px 0;
  }

  .planHidden {
    display: none;
  }

  .tipBox_yellow {
    padding: 4px 16px;
    border: 1px solid #ffe4ba;
    background-color: #fff7e8;
    border-radius: 6px;
    line-height: 20px;
    height: auto;
    color: #1D2129;
    font-size: 14px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    margin-left: 12px;

    img {
      width: 16px;
      height: 16px;
      margin-right: 10px;
    }
  }
}
</style>